export const GET_OBSERVER_ITEMS = 'GET_OBSERVER_ITEMS/all'
export const GET_OBSERVER_ITEM_SUBACCOUNTS = 'GET_OBSERVER_ITEM_SUBACCOUNTS/all'
export const THEME = 'THEME'
